export class     ObjectifSpecifique {
    code: any;
    libelle: string;
    programme_id: any;


    private errorMessage: string;

    constructor() {
        this.code = "";
        this.libelle = "";
      
        this.programme_id = 0;
       

        this.errorMessage = "";
    }

    canSave(): boolean {
        this.errorMessage = "";

        if (!this.libelle.trim()) {
            this.errorMessage = "Le libellé est requis.";
            return false;
        }

        if (!this.code.trim()) {
            this.errorMessage = "Le code est requis.";
            return false;
        }


        return true;
    }

    getErrorMessage(        ): string {
        return this.errorMessage;
    }
}
